import React from "react";
import { Input } from "@/components/ui/input";
import { countryDial, COUNTRIES } from "@/lib/countries";

// Phone field whose international prefix follows the selected country's dial code.
// Emits the full value as `+<dial><localdigits>`.
export function PhoneInput({ country, value, onChange, testid = "phone-input", required }) {
  const dial = countryDial(country) || "";
  // Keep only digits, then strip a leading dial code (prefer the current
  // country's, else the longest matching known dial) so switching countries
  // never leaves a stale prefix inside the local number.
  let local = String(value || "").replace(/\D/g, "");
  const dials = [dial, ...COUNTRIES.map((c) => c.dial)].filter(Boolean).sort((a, b) => b.length - a.length);
  for (const d of dials) {
    if (d && local.startsWith(d)) { local = local.slice(d.length); break; }
  }
  return (
    <div className="flex mt-1.5">
      <span className="inline-flex items-center px-3 h-11 rounded-l-xl border border-r-0 border-input bg-slate-50 text-sm text-slate-600 font-medium whitespace-nowrap" data-testid={`${testid}-dial`}>
        +{dial || "?"}
      </span>
      <Input required={required} type="tel" inputMode="numeric" value={local}
        onChange={(e) => onChange(`+${dial}${e.target.value.replace(/\D/g, "")}`)}
        placeholder="6 12 34 56 78" className="rounded-l-none rounded-r-xl h-11" data-testid={testid} />
    </div>
  );
}
